export const profileRuleset = {
  nameLength: [2, 14],
};
